<div class="main">
	<app-channel-slider [type]="'standard'"></app-channel-slider>
</div>
